import { render, staticRenderFns } from "./qcode.vue?vue&type=template&id=2188632e&scoped=true&"
import script from "./qcode.vue?vue&type=script&lang=js&"
export * from "./qcode.vue?vue&type=script&lang=js&"
import style0 from "./qcode.vue?vue&type=style&index=0&id=2188632e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2188632e",
  null
  
)

export default component.exports